import React from "react";
import Policial from "./Policial";

function PolicialList({ boletim, setBoletim }) {
  if (!boletim.efetivo?.length) return null;

  return (
    <div className="bo-section mt-4">
      <div className="bo-section-title">Efetivo Empregado</div>

      {boletim.efetivo.map((policial, index) => (
        <Policial
          key={policial._id || `${policial.id}:${index}`}
          index={index}
          policial={policial}
          boletim={boletim}
          setBoletim={setBoletim}
        />
      ))}
    </div>
  );
}

export default PolicialList;
